import React from 'react';
import { HeroUIProvider } from '@heroui/react';
import { LoginPage } from './pages/LoginPage';
import { AuthorizePage } from './pages/AuthorizePage';
import { DashboardPage } from './pages/DashboardPage';

function App() {
  const path = window.location.pathname;

  let Page: React.ComponentType;

  if (path === '/oauth/authorize' || path === '/authorize') {
    Page = AuthorizePage;
  } else if (path === '/dashboard') {
    Page = DashboardPage;
  } else {
    Page = LoginPage;
  }

  return (
    <HeroUIProvider>
      <Page />
    </HeroUIProvider>
  );
}

export default App;
